import React from "react";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import {Chip} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import {toGermanFormat} from "../../../../utils/numberFormater";

import styles from "./styles";


const AmountChip = ({classes, total=0, withValueClassName='green', subLine, customClasses={}}) => {
  return (
    <Grid container alignItems={"flex-end"} style={{height: '100%'}}>
      <Grid item xs={12} style={{height: '100%'}}>
        <Chip
          className={clsx(classes.totalValueChip, total > 0 && withValueClassName, customClasses.totalValueChip)}
          label={<>{toGermanFormat(total, '', ' €')}{subLine}</>}
        />
      </Grid>
    </Grid>
  )
};

export default withStyles(styles)(AmountChip);